/* ============================================================
   ACHAIAH — Custom JS
   Interactions légères — ne touche pas au cart.js du thème
   ============================================================ */

(function () {
  'use strict';

  /* ---- Barre de livraison : mise à jour quand le panier change ---- */
  var FREE_SHIPPING = 5000;

  function updateShippingBar(cartTotal) {
    var bars  = document.querySelectorAll('.achaiah-shipping-bar__fill');
    var texts = document.querySelectorAll('.achaiah-shipping-bar__text');
    if (!bars.length) return;
    var remaining = FREE_SHIPPING - cartTotal;
    var pct = Math.min(100, Math.round(cartTotal / FREE_SHIPPING * 100));
    bars.forEach(function (b) { b.style.width = pct + '%'; });
    texts.forEach(function (t) {
      if (remaining > 0) {
        var euros = (remaining / 100).toFixed(2).replace('.', ',');
        t.innerHTML = '🚚 Plus que <strong>' + euros + ' €</strong> pour la livraison offerte';
        t.classList.remove('achaiah-shipping-bar__text--success');
      } else {
        t.innerHTML = '✅ Félicitations ! La livraison est offerte sur votre commande';
        t.classList.add('achaiah-shipping-bar__text--success');
      }
    });
  }

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart != null) {
      updateShippingBar(e.detail.cart.total_price);
    }
  });

  /* ---- DOMContentLoaded ---- */
  document.addEventListener('DOMContentLoaded', function () {

    /* Header — ombre au scroll */
    var header = document.getElementById('header');
    if (header) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('wt-header--scrolled', window.scrollY > 50);
      }, { passive: true });
    }

    /* Retour en haut */
    var btn = document.createElement('button');
    btn.className = 'achaiah-back-to-top';
    btn.setAttribute('aria-label', 'Retour en haut de page');
    btn.innerHTML = '&#8593;';
    document.body.appendChild(btn);
    window.addEventListener('scroll', function () {
      btn.classList.toggle('achaiah-back-to-top--visible', window.scrollY > 400);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    /* Barre de lecture — articles uniquement */
    var articleBody = document.getElementById('achaiah-article-body');
    if (articleBody) {
      var progressWrap = document.createElement('div');
      progressWrap.className = 'achaiah-reading-progress';
      progressWrap.innerHTML = '<div id="achaiah-reading-bar" class="achaiah-reading-progress__bar"></div>';
      document.body.insertBefore(progressWrap, document.body.firstChild);
      var readBar = document.getElementById('achaiah-reading-bar');
      window.addEventListener('scroll', function () {
        var top = articleBody.getBoundingClientRect().top + window.scrollY;
        var h   = articleBody.offsetHeight;
        var pct = Math.min(100, Math.max(0, (window.scrollY - top) / h * 100));
        readBar.style.width = pct + '%';
      }, { passive: true });
    }

    /* Stock faible — fiche produit uniquement */
    var inventoryEl = document.querySelector('[data-inventory]');
    if (inventoryEl) {
      var qty = parseInt(inventoryEl.getAttribute('data-inventory'), 10);
      if (qty > 0 && qty <= 5) {
        var urgency = document.createElement('span');
        urgency.className = 'achaiah-stock-urgent ' +
          (qty <= 3 ? 'achaiah-stock-urgent--critical' : 'achaiah-stock-urgent--low');
        urgency.innerHTML = qty <= 3
          ? '⚡ Dernières pièces — ' + qty + ' en stock'
          : '⏳ Stock limité — ' + qty + ' restant' + (qty > 1 ? 's' : '');
        inventoryEl.parentNode.insertBefore(urgency, inventoryEl.nextSibling);
      }
    }

  });

})();
